import React, { createContext, useContext, useMemo, useState } from "react";
import { loadConsent, saveConsent } from "./storage";

const ConsentCtx = createContext(null);

export function ConsentProvider({ children }) {
  const [consent, setConsentState] = useState(() => loadConsent());
  const [preferencesOpen, setPreferencesOpen] = useState(false);

  const value = useMemo(() => ({
    consent,
    setConsent: (next) => setConsentState(saveConsent(next)),
    preferencesOpen,
    openPreferences: () => setPreferencesOpen(true),
    closePreferences: () => setPreferencesOpen(false),
  }), [consent, preferencesOpen]);

  return <ConsentCtx.Provider value={value}>{children}</ConsentCtx.Provider>;
}

export function useConsent() {
  const ctx = useContext(ConsentCtx);
  if (!ctx) throw new Error("useConsent must be used within ConsentProvider");
  return ctx;
}
